import axios from "axios";

export const instance = axios.create({
  baseURL: "https://walker-stores.com/",
  headers: {
    "content-type": "application/json",
  },
});
export const baseUrl = "https://walker-stores.com/images";
